/*globals jQuery */
( function( $ ) {
	'use strict';

	// Define global object.
	if ( typeof window.MSR !== 'object' ) {
		window.MSR = {};
	}

	window.MSR.prototype = ( function() {
		var init = function() {

			$( document ).on( 'click', '.show-more', function() {
				var self        = $( this );
				var contents    = self.html();
				var data_append = self.data( 'append' );
				var data_get    = self.data( 'get' );
				var container   = $( data_append );
				var action      = self.data( 'action' );
				var data        = {
					type_search:    self.data( 'filter_type' ),
					search:         self.data( 'filter' ),
					paged:          self.data( 'paged' ),
					posts_per_page: self.data( 'posts-per-page' ),
					post__in:       self.data( 'post-in' ),
					content_type:   self.data( 'content-type' ),
					item_template:  self.data( 'item-template' ),
					supports_moray: self.data( 'moray' ),
					video_type:     self.data( 'video-type' ),
					context:        self.data( 'context' ),
					connected_to:   self.data( 'connected-to'),
					orderby:        self.data( 'orderby'),
					col_classes:    self.data( 'columns' ),
					id :            self.data( 'connected-to' ),
				};

				triggerBI();

				self.attr( 'disabled', 'disabled' )
					.attr( 'aria-disabled', 'true' )
					.attr( 'aria-busy', 'true' )
					.removeClass( 'show-more' )
					.html( 'Loading' );

				switch ( self.data( 'item-template' ) && ! $( 'body' ).hasClass( 'author' ) ) {
						case 'project|card':
							data.posts_per_page = 12;
							break;
				}

				if ( action === 'get-videos' ) {
					data.year = self.data( 'year' );
				}

				// Load the new data
				getProfiles( data_get, data, data_append, self, function() {
					//reset aria data and enable button again
					self.attr( 'aria-disabled', 'false' )
						.attr( 'aria-busy', 'false' )
						.removeAttr( 'disabled' )
						.addClass( 'show-more' )
						.html( contents );
					//find the newly added content and give the first item focus for accessibility purposes.
					var $firstOfBatch = container.find( '.first-of-batch' );
					$firstOfBatch.removeAttr( 'tabindex' );
					$firstOfBatch.first().attr( 'tabindex', '0' ).focus();
					$firstOfBatch.removeClass( 'first-of-batch' );

					if ( self.data( 'item-template' ) === 'video|card' ) {
						container.append( $( '#show-more-wrapper' ) );
					}

					self.data( 'paged', data.paged + 1 );

				} );
			} );

			$( '.video-gallery-trigger' ).on( 'click', function( e ){
				e.preventDefault();

				var self         = $( this );
				var contents     = self.html();
				var data_replace = self.data( 'replace' );
				var data_get     = self.data( 'get' );
				var container    = $( data_replace );
				var loading      = false;
				var data         = {
					single_video: self.data( 'single-video' )
				};

				triggerBI();

				self.attr( 'aria-busy', 'true' );

				//scroll to the newly placed video
				$( 'html, body' ).animate( {

					scrollTop: $( data_replace ).offset().top

				}, 200, function() {

					if ( ! loading ) {

						//simulate loading with a timeout
						window.setTimeout( function(){
							getData( data_get, data, data_replace, function() {
								//activate jquery scripts on newly added DOM
								window.MSR.expandCollapse.init( { target: '.msr-video-ajax-content .msr-expandable-section' } );
								window.tabSet( '.c-tabs' );

								//reset aria data and enable button again
								self.attr( 'aria-busy', 'false' );
								//focus on added video elements
								container.attr( 'tabindex', '0' ).focus();
							} );
						}, 200 );

						loading = true;
					}
				} );
			} );
		};

		var triggerBI = function() {
			var self = $( this );

			window.MSR.wedecsBi.sendCustomEvent( self, {
				'ms.interactionType': 4
			} );
		};

		var getData = function( get, data, node, callback ){
			$.get( get, data, function( response ) {
				//create container for retrieved data so we can manipulate it with jquery.
				//append a class to all child content to setup a css animation

				if ( ! response || ! response.posts[ 0 ] || ! response.posts[ 0 ].html ) {
					return;
				}

				var html = response.posts[ 0 ].html;

				var content = $( '<div></div>' ).append( html ).addClass( 'setup-animation' );

				//append this content to our specified in-page container
				$( node ).html( content );

				window.setTimeout( function() {
					//set animate class
					$( node ).find( '.setup-animation' ).addClass( 'animate-in' );
					//run callback functions
					if ( typeof( callback ) === 'function' ) {
						callback();
					}
				}, 10 );

			} );
		};

		var getProfiles = function( get, data, node, show_more_button, callback ) {
			$.get( get, data, function( response ) {
				//create container for retrieved data so we can manipulate it with jquery.
				//append a class to all child content to setup a css animation

				var html = '';
				var items = Array();

				if ( response ) {
					switch ( node ) {
						case '#people-list' :
							items = response.researchers;
							break;

						case '#video-list' :
							items = response.posts;
							break;

						case '#related-posts-articles' :
							items = response.content;
							break;

						default:
							items = response.posts;
							break;
					}

					// To prevent undefined responses, fallback to empty array
					items = items || [];

					for( var i = 0; i < items.length; i++ ) {
						if ( items[i].html ) {
							html += items[i].html;
						}
					}
				}

				if ( items.length === 0 || ( 'posts_per_page' in data && items.length < parseInt( data.posts_per_page ) ) || ! response.more_pages ) {
					show_more_button.hide();
				}

				var content = $( '<div></div>' ).append( html ).children().addClass( 'setup-animation' );
				content.first().find('a').addClass('first-of-batch');

				//append this content to our specified in-page container
				$( node ).append( content );

				window.setTimeout( function(){
					//set animate class
					$( node ).find( '.setup-animation' ).addClass( 'animate-in' );
					//run callback functions
					if ( typeof( callback ) === 'function' ) {
						callback();
					}
				}, 10 );

			} );
		};

		return {
			init: init
		};
	} )();

	$( function() {
		window.MSR.prototype.init();
	} );

} ) ( jQuery );
